module.exports = __webpack_public_path__ + "img/m-afpi.27fd15f6.png";